import { AssetSchema, AssetService } from '@dtx-company/connect-codegen/src/gen/asset/v1/asset_pb'
import { Client, createClient } from '@connectrpc/connect'
import { CodeSchema } from '@dtx-company/connect-codegen/src/gen/codes/v2/code_pb'
import { PageSchema as V1Page } from '@dtx-company/connect-codegen/src/gen/pages/v1/page_pb'
import { PageSchema as V2Page } from '@dtx-company/connect-codegen/src/gen/pages/v2/page_pb'
import { createConnectTransport } from '@connectrpc/connect-web'
import { createRegistry } from '@bufbuild/protobuf'
import { getBaseUrl } from '../utils/url'

export const assetTypeRegistry = createRegistry(CodeSchema, V1Page, V2Page, AssetSchema)

export const getAssetsClientBaseUrl = (): string => getBaseUrl('assets/', process.env.APP_ENV)

const assetsClient: Client<typeof AssetService> = createClient(
  AssetService,
  createConnectTransport({
    baseUrl: getAssetsClientBaseUrl(),
    jsonOptions: {
      ignoreUnknownFields: true,
      registry: assetTypeRegistry
    }
  })
)

export default assetsClient
